<template>
  <div class="parking-items-container">
    <!-- <div class="parking-list two-columns"> -->

    <div v-for="(lot, index) in filteredLots" :key="index" class="parking-item" :ref="'lot-' + index"
      :class="{ 'parking-item-selected': selectedLot && selectedLot.title === lot.title }" @click="handleLotClick(lot)">
      <div class="image-td">
        <img :src="getFullImageURL(lot.photo_url)" alt="Parking Lot" />
      </div>
      <div class="text-info">
        <h3>{{ lot.title }}</h3>
        <!-- 剩餘車位：號誌燈依空位比例，綠 50% 以上、黃 10% 以上、紅 10% 以下 -->
        <!-- 滿場不另外標示，0% 本就落在紅燈級距，一律以「剩餘車位 10% 以下」呈現 -->
        <!-- 後台勾選 is_remain_actual 的場站改顯示實際車位數，燈號仍依比例 -->
        <div class="parking-capacity">
          <template v-if="remainOf(lot)">
            <span class="capacity-light" :class="remainOf(lot).level"></span>
            <span class="capacity-text">剩餘車位 {{ remainOf(lot).displayText }}</span>
          </template>
        </div>

        <!-- <p>{{ "  " }} </p> -->
        {{ lot.address }}
      </div>
      <!-- <td style="width: 20%" class="parking-type-td">
              <button class="parking-type">{{ lot.parking_type || '未知類型' }}</button>
            </td> -->
      <div class="parking-type-div">
        <button v-for="(type, index) in getParkingType(lot)" :key="index" class="parking-type">
          {{ type }}
        </button>
        <button v-if="lot.is_rent" class="rent-type">
          月租場
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { onImageError, getParkingType , getFullImageURL, getRemainSpace} from '@/util/util';

export default {
  props: {
    filteredLots: {
      type: Array,
      required: true
    },
    selectedLot: {
      type: Object,
      default: null
    }
  },
  watch: {
    selectedLot(newVal) {
      // When selected lot changes, scroll into view if possible
      if (newVal) {
        const selectedIndex = this.filteredLots.indexOf(newVal);
        if (selectedIndex !== -1 && this.$refs['lot-' + selectedIndex]) {
          this.$nextTick(() => {
            const element = this.$refs['lot-' + selectedIndex];
            const el = Array.isArray(element) ? element[0] : element;
            if (el && el.scrollIntoView) {
              el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          });
        }
      }
    }
  },
  methods: {
    getFullImageURL,
    onImageError,
    getParkingType,
    // null 代表不顯示（功能未開啟、場站未啟用、無數值或資料過期）
    remainOf(lot) {
      return getRemainSpace(lot);
    },
    handleLotClick(lot) {
      this.$emit('select', lot);
    }
  }
};
</script>

<style scoped>
.parking-items-container {
  flex: 1;
  /* overflow-y: auto; */
  /* padding: 10px; */
  padding-bottom: 16px;
  background-color: var(--background-gray);

  display: flex;
  flex-direction: column;
  gap: 16px;
}


.parking-item-selected {
  border: 2px solid var(--green03);
}

.parking-item {
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;

  width: 440px;
  height: 104px;

  border-radius: 12px;


  /* margin: 10px; */
  padding: 16px;
  /* padding: 10px; */
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

  box-sizing: border-box;
  /* box-sizing: border-box; */
}


.image-td {
  width: 72px;
  height: 72px;
  border-radius: 12px;
  overflow: hidden;
}

.image-td img {

  width: 100%;
  height: 100%;

  object-fit: cover;

}

/* ---- 剩餘車位（場站名稱與地址之間）---- */
/* 卡片高度固定 104px，此列須維持在 18px 以內 */
.parking-capacity {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 18px;
  line-height: 18px;
}

.capacity-light {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex: none;
}

.capacity-light.green {
  background-color: #12a150;
  box-shadow: 0 0 0 2px rgba(18, 161, 80, 0.18);
}

.capacity-light.yellow {
  background-color: #e0a020;
  box-shadow: 0 0 0 2px rgba(224, 160, 32, 0.18);
}

.capacity-light.red {
  background-color: #d0342c;
  box-shadow: 0 0 0 2px rgba(208, 52, 44, 0.18);
}

.capacity-text {
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  color: var(--gray13);
  white-space: nowrap;
}

.text-info {
  padding: 0px;
  text-align: left;

  /* margin-left:18px; */
  padding-left: 17px;

  /* //styleName: sm/regular; */
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 21.56px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


  white-space: nowrap;
  /* Prevent text from wrapping */
  overflow: hidden;
  /* Hide overflow text */
  text-overflow: ellipsis;
  /* Show ellipsis (...) for overflow text */


  color: var(--gray15);
}

.text-info h3 {
  margin: 0;
  padding-top: 0;
  /* text-wrap: nowrap; */

  /* //styleName: lg/bold; */
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


  color: var(--gray15);

}


/* 原為空 div 佔位用的 28px；現在放剩餘車位，須配合卡片
   內容區高度（104 - 16*2 = 72px）：標題 26.1 + 本列 18 + 地址 21.56 = 65.66 */
.parking-capacity {
  height: 18px;
}

.text-info p {
  margin: 0;
  padding-top: 8px;

  /* //styleName: sm/bold; */
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
  line-height: 21.56px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--green03);
}



.parking-type-div {
  position: absolute;
  top: 16px;
  right: 12px;
  width: 100px;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* justify-content: flex-end; */
  gap: 3px;
}

.parking-type {
  padding: 5px 10px;
  background-color: var(--green05);
  border: none;
  cursor: pointer;

  /* width: 48px; */
  height: 26px;
  top: 16px;
  left: 632px;
  padding: 4px 6px 4px 6px;
  gap: 10px;
  border-radius: 8px;

  /* //styleName: xs/bold; */
  font-family: Inter;
  font-size: 12px;
  font-weight: 700;
  line-height: 18.48px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


  color: white;
  text-wrap: nowrap;

  /* z-index:100; */

}



.rent-type {
  padding: 5px 10px;
  background-color: var(--yellow1);
  border: none;
  cursor: pointer;

  /* width: 48px; */
  height: 26px;
  top: 16px;
  left: 632px;
  padding: 4px 6px 4px 6px;
  gap: 10px;
  border-radius: 8px;

  /* //styleName: xs/bold; */
  font-family: Inter;
  font-size: 12px;
  font-weight: 700;
  line-height: 18.48px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


  color: black;
  text-wrap: nowrap;

  /* z-index:100; */

}

@media screen and (max-width: 560px) {



  .parking-item {
    width: 343px;
    height: 88px;
    padding: 12px;
  }

  /* 內容區 88 - 12*2 = 64px：標題 24 + 本列 16 + 地址 21.56 = 61.56 */
  .parking-capacity {
    height: 16px;
  }

  .capacity-light {
    width: 8px;
    height: 8px;
  }

  .capacity-text {
    font-size: 12px;
  }

  .image-td {
    width: 64px;
    height: 64px;
    border-radius: 10.67px;
    overflow: hidden;
  }

  .image-td img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .text-info {
    padding: 0px;
    text-align: left;
    padding-left: 12px;

    /* //styleName: sm/regular; */
    font-size: 14px;
    line-height: 21.56px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    width:184px;

  }

  .text-info h3 {
    padding-top: 0;

    /* //styleName: md/bold; */
    font-size: 16px;
    line-height: 24px;


  }

  .text-info p {
    margin: 0;
    padding-top: 2px;

    /* //styleName: sm/bold; */
    /* //styleName: xs/bold; */
    font-size: 12px;
    line-height: 18.48px;


  }

  .parking-type-div {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 100px;

    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 3px;



  }

  .parking-type {


    padding: 4px 6px 4px 6px;
    border-radius: 8px;

    /* //styleName: xs/bold; */
    font-size: 12px;
    font-weight: 700;
    line-height: 18.48px;

  }

  .rent-type {


    padding: 4px 6px 4px 6px;
    border-radius: 8px;

    /* //styleName: xs/bold; */
    font-size: 12px;
    font-weight: 700;
    line-height: 18.48px;

  }

}
</style>
